import { defineStore } from 'pinia'
import creditNoteApi from '@vue3/api/credit-note-api'
import { detectMimeTypeFromBytes, getMimeTypeFromFileName } from '@vue3/utils/file'

const creditNoteStore = defineStore('creditNoteStore', {
  state: () => ({
    isCountFetching: false,
    isCreditNoteCountError: false,
    creditNoteList: [],
    quotationList: [],
    creditNoteCount: 0,
    isQuotationAvailable: false
  }),
  actions: {
    getCreditNoteCount ({ params, success = null, fail = null } = {}) {
      this.isCountFetching = true
      creditNoteApi.getCreditNoteCount(params).then(res => {
        this.isCountFetching = false
        const resBody = res?.body
        if (resBody.success) {
          this.isCreditNoteCountError = false
          this.creditNoteCount = resBody?.value?.totalCount || 0
          success && success(res.body)
        } else {
          this.isCountFetching = false
          this.isCreditNoteCountError = true
          fail && fail(resBody)
        }
      }).catch(err => {
        this.isCountFetching = false
        this.isCreditNoteCountError = true
        this.missionDetail = {}
        fail && fail(err)
      })
    },
    getAvailableCreditNote ({ params, success = null, fail = null } = {}) {
      creditNoteApi.getAvailableCreditNote(params).then(res => {
        const resBody = res?.body
        if (resBody?.success) {
          const currentResponse = resBody.content || []
          this.creditNoteList = this.creditNoteList.length ? this.creditNoteList.concat(currentResponse) : currentResponse
          const pageMetaData = resBody?.pageMetaData || {}
          success && success(pageMetaData)
        } else {
          if (!this.creditNoteList.length) {
            this.creditNoteList = []
          }
          fail && fail()
        }
      }).catch(err => {
        if (!this.creditNoteList.length) {
          this.creditNoteList = []
        }
        fail && fail(err)
      })
    },
    resetCreditNoteList () {
      this.creditNoteList = []
    },
    downloadCreditNotePdf ({ params, success, fail }) {
      creditNoteApi.downloadCreditNotePdf(params).then(res => {
        const resBody = res?.body
        const resValue = resBody?.value
        if (resBody?.success && resValue?.fileBytes) {
          const responseFileName = resValue?.fileName
          const fileName = responseFileName || `${params.claimNumber}.pdf`
          const rawFileBytes = resValue.fileBytes
          const base64Data = rawFileBytes.includes(',') ? rawFileBytes.split(',').pop() : rawFileBytes
          const binaryString = window.atob(base64Data)
          const byteArray = new Uint8Array(binaryString.length)
          for (let i = 0; i < binaryString.length; i++) {
            byteArray[i] = binaryString.charCodeAt(i)
          }
          const detectedMimeType = responseFileName ? detectMimeTypeFromBytes(byteArray) : null
          const mimeType = responseFileName
            ? (detectedMimeType || getMimeTypeFromFileName(fileName))
            : 'application/pdf'
          let finalFileName = fileName
          if (detectedMimeType && fileName.toLowerCase().endsWith('.pdf')) {
            const extensionMap = {
              'image/jpeg': '.jpg',
              'image/png': '.png'
            }
            const newExtension = extensionMap[detectedMimeType]
            if (newExtension) {
              finalFileName = fileName.replace(/\.pdf$/i, newExtension)
            }
          }
          const blob = new Blob([byteArray], { type: mimeType })
          const url = window.URL.createObjectURL(blob)
          success && success({ url, base64Data }, finalFileName)
          setTimeout(() => window.URL.revokeObjectURL(url), 100)
        } else {
          fail && fail()
        }
      }).catch(err => {
        fail && fail(err)
      })
    },
    checkQuotationAvailability ({ params, success = null, fail = null } = {}) {
      creditNoteApi.getAvailableQuotation(params).then(res => {
        const resBody = res?.body
        if (resBody?.success) {
          this.quotationList = resBody?.content || []
          this.isQuotationAvailable = resBody?.content.length
          success && success(resBody)
        } else {
          this.quotationList = []
          this.isQuotationAvailable = false
          fail && fail(resBody)
        }
      }).catch(err => {
        this.quotationList = []
        this.isQuotationAvailable = false
        fail && fail(err)
      })
    },
    getAvailableQuotation ({ params, success = null, fail = null } = {}) {
      creditNoteApi.getAvailableQuotation(params).then(res => {
        const resBody = res?.body
        if (resBody?.success) {
          this.quotationList = resBody?.content || []
          success && success(resBody)
        } else {
          this.quotationList = []
          fail && fail(resBody)
        }
      }).catch(err => {
        this.quotationList = []
        fail && fail(err)
      })
    },
    createClaimRequest ({ params = {}, payload = {}, success = null, fail = null } = {}) {
      creditNoteApi.createClaimRequest(params, payload).then(res => {
        const resBody = res?.body
        if (resBody?.success) {
          success && success(resBody)
        } else {
          fail && fail(resBody)
        }
      }).catch(err => {
        fail && fail(err)
      })
    },
    requestActivation ({ params = {}, payload = {}, success = null, fail = null } = {}) {
      creditNoteApi.requestActivation(params, payload).then(res => {
        const resBody = res?.body
        if (resBody?.success) {
          success && success(resBody)
        } else {
          fail && fail(resBody)
        }
      }).catch(err => {
        fail && fail(err)
      })
    },
    uploadCreditNoteFile ({ data, success = null, fail = null } = {}) {
      creditNoteApi.uploadCreditNoteFile(data).then(res => {
        const resBody = res?.body
        if (resBody?.success) {
          success && success(resBody)
        } else {
          fail && fail(resBody)
        }
      }).catch(err => {
        fail && fail(err)
      })
    }
  }
})
export default creditNoteStore
